import { post, upload } from ".";

const signIn = (payload) => {
  const request = {
    subUrl: "login",
    data: payload,
    isAuth: true,
  };
  return post(request);
};

const mobileSendOtp = (payload) => {
  const request = {
    subUrl: "requestotp",
    data: payload,
    isAuth: true,
  };
  return post(request);
};
const emailSendOtp = (payload) => {
  const request = {
    subUrl: "sendotpemail",
    data: payload,
    isAuth: true,
  };
  return post(request);
};

const signOut = (payload) => {
  const request = {
    subUrl: "logout",
    data: payload,
    isAuth: true,
  };
  return post(request);
};

const verifyOtp = (payload) => {
  const request = {
    subUrl: "verifyotp",
    data: payload,
    isAuth: true,
  };
  return post(request);
};

const registerUser = (payload) => {
  const request = {
    subUrl: "register2",
    data: payload,
    isAuth: true,
  };
  return post(request);
};
const registerProfessional = (payload) => {
  const request = {
    subUrl: "registerprofessional",
    data: payload,
    isAuth: true,
  };
  return post(request);
};

const registerCorporateUser = (payload) => {
  const request = {
    subUrl: "registercorporateuser",
    data: payload,
    isAuth: true,
  };
  return post(request);
};

const forgotPassword = (payload) =>{
  const request = {
    subUrl: "forgot-password",
    data: payload,
    isAuth: true,
  };
  return post(request);
}

const resetPassword = (payload) => {
  const request = {
    subUrl: "reset-password",
    data: payload,
   isAuth: true,
  };
  return post(request);
}


const uploadProfessionalDocuments = (formData) => {
 return upload({
    subUrl: "Attachments/upload-professional-certificates",
    data: formData,
    isAuth: false,
  });
}

const authApi = {
  signIn,
  signOut,
  verifyOtp,
  mobileSendOtp,
  emailSendOtp,
  registerProfessional,
  registerUser,
  registerCorporateUser,
  forgotPassword,
  resetPassword,
  uploadProfessionalDocuments
};

export default authApi;
